'use client'

import { LayoutBreadcrumbsOverride } from '@/app/layout/MainSiteLayout/LayoutBreadcrumbsOverride'

import { Catalog } from '@/screens/catalog'

import { AggregateOfferSchemaScript } from '@/features/catalog/aggregate-offer-schema'
import { CatalogInitialDataProvider } from '@/features/catalog/catalog-initial-data'
import type { CatalogSeoLinks } from '@/features/catalog/catalog-initial-data'
import { useCatalogProducts } from '@/features/catalog/catalog-products'
import { useFilter } from '@/features/catalog/filter'
import { MindboxCatalogPageView } from '@/features/catalog/mindbox-catalog-page-view'
import { ProductListSchemaScript } from '@/features/catalog/product-list-schema-script'

import { CatalogProductsData, FilterData, StepFilterProperty } from '@/entities/catalog-old'

import { useCurrentCategory } from '@/shared/lib/hooks/useCurrentCategory'
import { TPage } from '@/shared/types/deprecated-types'

type Props = {
	breadcrumbs: TPage[]
	initialFilterData: FilterData | null
	initialProductsData: CatalogProductsData | null
	initialSeoLinks: CatalogSeoLinks | null
	initialStepFilterData: StepFilterProperty[] | null
	initialResolvedUrl: string
}

const CatalogPageContent = () => {
	const { currentCategory } = useCurrentCategory()
	const { filterUrl } = useFilter()
	const { products, totalProducts } = useCatalogProducts(filterUrl)

	return (
		<>
			<AggregateOfferSchemaScript
				products={products}
				totalProducts={totalProducts}
				categoryTitle={currentCategory.title}
				categoryImg={currentCategory.imgSrc}
			/>
			<ProductListSchemaScript products={products} category={currentCategory} />
			<MindboxCatalogPageView />
			<Catalog />
		</>
	)
}

export const CatalogClient = ({
	breadcrumbs,
	initialFilterData,
	initialProductsData,
	initialSeoLinks,
	initialStepFilterData,
	initialResolvedUrl
}: Props) => {
	return (
		<>
			<LayoutBreadcrumbsOverride pages={breadcrumbs} />
			<CatalogInitialDataProvider
				value={{
					initialFilterData,
					initialProductsData,
					initialSeoLinks,
					initialStepFilterData,
					initialResolvedUrl
				}}>
				<CatalogPageContent />
			</CatalogInitialDataProvider>
		</>
	)
}
